import {Injectable} from "@angular/core";
import {Subject} from "rxjs";


@Injectable()
export class CustomModalService {
  private _modalcontent = new Subject<string>();
  _modalcontent$ = this._modalcontent.asObservable();

  private _switchmodal = new Subject<boolean>();
  _switchmodal$ = this._switchmodal.asObservable();

  private defaultModalComponent = 'add-outlet';


  setModalContent(componentName:string):void{
    this._modalcontent.next(componentName);
    this._switchmodal.next(true);
  }

  closeModal():void{
    this._modalcontent.next(this.defaultModalComponent);
    this._switchmodal.next(false);
  }

}
